// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"224":"df4818d1","3110":"93e768b3","6366":"3e154e90","9378":"a840ab33"}[chunkId] + ".chunk.css";
};